// Core packages
import { NgModule } from '@angular/core';

// Third party packages

// Custom packages - Modules
import { AccessLogsRoutingModule } from './access-logs-routing.module';
// import { PublicModule } from 'src/app/modules/public/public.module';
import { SharedModule } from '../shared.module';

// Custom packages - Components
import { AccessLogsListComponent } from 'src/app/modules/access-logs/pages/access-logs-list/access-logs-list.page';

@NgModule({
  imports: [
    // Shared modules
    SharedModule,

    // Custom
    AccessLogsRoutingModule,
    // PublicModule,
  ],
  declarations: [
    AccessLogsListComponent,
  ],
  entryComponents: [
  ],
  exports: [
  ]
})
export class AccessLogsModule { }
